import { Wrapper } from '@american-autonomy/ag-ui';

import ActivityCardItem from 'components/ActivityCard/components/ActivityCardItem';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ActivityCardItems: FunctionComponent<Props> = ({
    className = '',
    items = [],
    testId = TEST_ID
}) => (
    <Wrapper className={`${className} ${styles.activityCardItems}`} testId={testId}>
        {items.map(({ createdAt, detailsUrl, name }, index: number) => (
            <Wrapper className={styles.wrapper} key={`${name}-${index}`}>
                <ActivityCardItem
                    date={new Date(createdAt)}
                    detailsUrl={detailsUrl}
                    text={name ?? ''}
                />
            </Wrapper>
        ))}
    </Wrapper>
);

export default ActivityCardItems;
